import { MessageBoxButton, userInteraction } from "@eusoft/webapp-framework/services/UserInteraction";
import { forModel } from "@eusoft/webapp-jsx";
import { Content, contentInfo,  formatText, MaterialIcon, Message, ObjectEditor,  required, type IAction } from "@eusoft/webapp-ui";
import { DeviceType, type Guid } from "../../entities/Commands";
import { executeAsync } from "../../services/DataService";
import { isNativeApp, nativeApp } from "../../services/NativePayment";
import { userSession } from "../../services/UserSession";
import type { IContextInfo } from "../../components/ContextView";
import { registerComponent } from "@eusoft/webapp-core/Component";

export interface IRegisterDeviceArgs {
    action?: () => Promise<unknown>;
}

interface IDeviceData {
    name: string;
    makePrimary: boolean;
    nameDisabled: boolean;
}

export class RegisterDevicePage extends Content<IRegisterDeviceArgs> implements IContextInfo {
    private _backAction: () => Promise<unknown>;

    constructor() {

        super();

        const actions = [{
            executeAsync: () => this.registerDeviceAsync(),
            name: "register",
            priority: "primary",
            text: "register"
        }] as IAction[];

        this.init(RegisterDevicePage, {
            title: "register-device",
            style: ["panel"],
            actions: actions,
            body: forModel(this, m => <>
                <Message type="info">
                    {formatText("msg-register-device")}
                    {!m.data.nameDisabled && <>{formatText("msg-register-select-name")}</>}
                </Message>
                <MaterialIcon style="page-icon" name="phonelink_ring" />
                <ObjectEditor<IDeviceData>
                    commitMode="auto-inplace"
                    value={m.data}
                    validationMode="onInputChange"
                    isValid={m.isValid}
                    inputField={{ style: "filled" }}
                    builder={bld => <>
                        {bld.text(a => a.name, {
                            disabled: a => a.nameDisabled,
                            validators: [required]
                        })}
                        {bld.boolean(a => a.makePrimary, {
                            visible: a => !a.nameDisabled,
                        })}
                    </>
                    } />
            </>)
        });
    }

    protected override async onLoadAsync(args: IRegisterDeviceArgs) {

        this._backAction = args?.action;
        this.data.name = userSession.active?.deviceName ?? "";
        console.log(this.data.name);
        if (this.data.name)
            this.data.nameDisabled = true;
        return true;
    }


    async registerDeviceAsync(name?: string) {

        let deviceId: Guid;

        if (!this.isValid)
            return;

        if (isNativeApp()) {

            if (!nativeApp.ensureDeviceSecure(false)) {

                await userInteraction.messageBoxAsync("msg-device-must-be-secure", "warning", MessageBoxButton.Ok);

                nativeApp.ensureDeviceSecure(true);

                return;
            }

            const info = nativeApp.getDeviceInfo();

            let token: string;

            try {
                token = await nativeApp.getFcmTokenAsync();
            }
            catch (ex) {
                console.error("getFcmTokenAsync", ex);
            }

            deviceId = await executeAsync("RegisterDevice", {
                info: info,
                serial: info.serial,
                type: DeviceType.Android,
                friendlyName: this.data.name,
                //isPrimary: true,
                fcmToken: token,
                posKeys: nativeApp.getTrustChain("pos"),
                authKeys: nativeApp.getTrustChain("auth")
            }, {method: "POST"});

            try {
                await nativeApp.authorizeKeyAsync("pos");
                await nativeApp.authorizeKeyAsync("auth");
            }
            catch (ex) {
                console.error("authorizeKeyAsync", ex);
                userInteraction.messageAsync(ex.message, "error", 5000);  
            }
        }
        else
            deviceId = crypto.randomUUID();

        userSession.deviceId = deviceId;

        if (this._backAction)
            this._backAction();
        else
            this.host.closeAsync(true);
    }

    hideContext = true;

    hideBottomNav = true;

    isValid: boolean;

    nameDisabled: boolean;

    data: IDeviceData = {} as IDeviceData;  

    result: boolean;

    static override info = contentInfo({
        name: "register-device",
        route: "/devices/register",
        factory: () => new RegisterDevicePage(),
        features: [

        ]
    });
}

registerComponent(RegisterDevicePage, "RegisterDevicePage");